@if (indicators && indicators.length > 0) {
  <p-carousel
    [value]="indicators"
    [showNavigators]="false"
    [showIndicators]="indicators.length > 1"
    [numVisible]="1"
    [numScroll]="1"
    class="align-items-start justify-content-start text-left">
    <ng-template let-indicator pTemplate="item">
      <app-indicator-meta-data [indicator]="indicator" />
    </ng-template>
  </p-carousel>
} @else {
  <div
    class="absolute z-3 text-center text-2xl text-color-secondary flex align-items-center justify-content-center h-full w-full gap-3 surface-ground p-5">
    <div class="flex flex-column gap-1">
      <div class="flex gap-3 align-items-center justify-content-center">
        <i class="fa-solid fa-person-digging"></i>
        <i>Keine Indikatoren verfügbar</i>
      </div>
    </div>
  </div>
}
